import { AVAILABLE_ICONS_MAP, DEFAULT_ICON } from '../config/icon.config.js'

function getIcon(id) {
  if (id == null || id === '') return DEFAULT_ICON
  return AVAILABLE_ICONS_MAP.get(id) ?? DEFAULT_ICON
}

class IconUtility {
  /**
   * Resolve a registry id to a Vue icon component. Missing or unknown ids
   * fall back to the blank icon.
   *
   * @param {string|null|undefined} id
   * @returns {import('vue').Component}
   */
  get(id) {
    return getIcon(id)
  }

  /**
   * Resolve a settings category document to its icon component. Expects
   * `{ icon: { name, src } }`; bare ids (deleted / not loaded) fall back
   * to the blank icon.
   *
   * @param {string|object|null|undefined} categoryRef
   * @returns {import('vue').Component}
   */
  category(categoryRef) {
    if (categoryRef == null || typeof categoryRef !== 'object') return DEFAULT_ICON
    return getIcon(categoryRef.icon?.name || categoryRef.icon?.src)
  }
}

export default new IconUtility()
